import { StoryblokComponent, storyblokEditable } from "@storyblok/react";


const LandingPage = ({ blok }) => {
  return (
    <>
      <div {...storyblokEditable(blok)} className="font-display ">
        <div className="container herosub landing-header">
          <div className="landing-left">
          <h1>{blok.title}</h1>
          <h2>{blok.subtitle}</h2>
          </div>
          <div className="landing-right">
            {/* {blok.form} */}
          </div>
        </div>

        <div className="font-display text-left">
          <div className="intro-fitness">
            <h2>{blok.intro}</h2>
          </div>
          <div className="card-grid fitness">
            {blok.grid
              ? blok.grid.map((blok) => (
                  <StoryblokComponent blok={blok} key={blok._uid} />
                ))
              : null}
          </div>
        </div>
      </div>
    
    </>
  );
};

export default LandingPage;
